import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import { AnimatePresence, motion } from 'framer-motion';
import RegisterPage from './pages/authPages/RegisterPage';
import LoginPage from './pages/authPages/LoginPage';
import HomeAfterLogin from './pages/HomeAfterLogin';
import PromotionsPage from './pages/Promotions/Promotions';
import HomePage from './pages/HomePage';
import PlayGame from './pages/PlayGame/PlayGame';
import GameResult from './pages/GameResult/GameResult';
import GameResultDetails from './pages/GameResult/GameResultDetails';
import Account from './pages/Account/Account';
import ViewDetails from './pages/ViewDetails/ViewDetails';
import Keypad from './pages/Keypads/Keypad';
import Transaction from './pages/Transactions/Transaction';
import Commission from './pages/Commission/Commission';
import Report from './pages/Reports/Report';
import UserReport from './pages/UserReport/UserReport';
import Logs from './pages/Logs/Logs';
import Profile from './pages/Profile/Profile';
import LoadRequest from './pages/LoadRequest/LoadRequest';
import WithDrawRequest from './pages/WithDrawRequest/WithDrawRequest';
import ManageGames from './pages/ManageGames/ManageGames';
import User from './pages/Users/User';
import Users2 from './pages/UsersImp/UsersImp';
import UpdateUser from './pages/UpdateUser/UpdateUser';
import UserGames from './pages/UsersImp/UserGames';
import { useContext, useEffect } from 'react';
import LeftToRightPageWrapper from './components/common/LeftToRightPageWrapper ';
import RightToLeftPageWrapper from './components/common/RightToLeftPageWrapper';
import { NavigationContext } from './context/NavigationContext';
import ProtectedRoute from './components/ProtectedRoute';
import ForgotPasswordPage from './pages/authPages/ForgotPasswordPage';
import Bets from './pages/Bets/Bets';
import GameSettings from './pages/GameSettings/GameSettings';
import HomePageSettings from './pages/HomePageSettings/HomePageSettings';
import DefaultGamePackages from './pages/DefaultGamePackages/DefaultGamePackages';
import { WebSocketProvider } from './context/WebSocketContext';
import { BottomNavProvider } from './context/BottomNavContext';
import UpdateNotifier from './components/UpdateNotifier';
import Settings from './pages/Settings/Settings';
import BetLimits from './pages/BetLimits/BetLimits';
import HotNumbers from './pages/HotNumbers/HotNumbers';
import CreateFinanceOfficer from './pages/FinanceOfficer/CreateFinanceOfficer';
import FinanceOfficers from './pages/FinanceOfficer/FinanceOfficers';
import OverallBetLimits from './pages/OverallBetLimits/OverallBetLimits';
import PaymentTransactions from './pages/PaymentTransaction';
import PaymentRequest from './pages/PaymentRequest';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import About from './pages/About';
import Contact from './pages/Contact';
import DepositPage from './pages/DepositPage';
import Support from './pages/Support';

import MusicPlayer from './components/common/MusicPlayer';
import TermsNoticePopup from './components/Popup/TermsNoticePopup';
import { useTermsNotice } from './hooks/useTermsNotice';

function AppContent() {
  const location = useLocation();
  const { isBackNavigation } = useContext(NavigationContext);

  return (
    <Routes>
      {/* Public Routes */}
      <Route path='/home' element={<HomePage />} />
      <Route path='/login' element={<LoginPage />} />
      <Route path='/register' element={<RegisterPage />} />
      <Route path='/forgot-password' element={<ForgotPasswordPage />} />
      <Route path='/privacy-policy' element={<PrivacyPolicy />} />
      <Route path='/terms' element={<TermsOfService />} />
      <Route path='/about' element={<About />} />
      <Route path='/contact' element={<Contact />} />

      {/* Protected Routes */}
      <Route path='/promotions' element={<PromotionsPage />} />
      <Route
        path='/play-game'
        element={
          <ProtectedRoute>
            <PlayGame />
          </ProtectedRoute>
        }
      />
      <Route
        path='/game-results'
        element={
          <ProtectedRoute>
            <GameResult />
          </ProtectedRoute>
        }
      />
      <Route
        path='/account'
        element={
          <ProtectedRoute>
            <Account />
          </ProtectedRoute>
        }
      />
      <Route
        path='/game-results/:id'
        element={
          <ProtectedRoute>
            <ViewDetails />
          </ProtectedRoute>
        }
      />
      <Route
        path='/keypad'
        element={
          <ProtectedRoute>
            <Keypad />
          </ProtectedRoute>
        }
      />
      <Route
        path='/transactions'
        element={
          <ProtectedRoute>
            <Transaction />
          </ProtectedRoute>
        }
      />
      <Route
        path='/commissions'
        element={
          <ProtectedRoute>
            <Commission />
          </ProtectedRoute>
        }
      />
      <Route
        path='/reports'
        element={
          <ProtectedRoute>
            <Report />
          </ProtectedRoute>
        }
      />
      <Route
        path='/user-reports'
        element={
          <ProtectedRoute>
            <UserReport />
          </ProtectedRoute>
        }
      />
      <Route
        path='/logs'
        element={
          <ProtectedRoute>
            <Logs />
          </ProtectedRoute>
        }
      />
      <Route
        path='/profile'
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />
      <Route
        path='/load-request'
        element={
          <ProtectedRoute>
            <LoadRequest />
          </ProtectedRoute>
        }
      />
      <Route
        path='/withdrawal-request'
        element={
          <ProtectedRoute>
            <WithDrawRequest />
          </ProtectedRoute>
        }
      />
      <Route
        path='/games-package'
        element={
          <ProtectedRoute>
            <ManageGames />
          </ProtectedRoute>
        }
      />
      <Route
        path='/game-settings'
        element={
          <ProtectedRoute allowedRoles={[1]}>
            <GameSettings />
          </ProtectedRoute>
        }
      />
      <Route
        path='/default-game-packages'
        element={
          <ProtectedRoute allowedRoles={[1]}>
            <DefaultGamePackages />
          </ProtectedRoute>
        }
      />
      <Route
        path='/bet-limits'
        element={
          <ProtectedRoute allowedRoles={[1]}>
            <BetLimits />
          </ProtectedRoute>
        }
      />
      <Route
        path='/overall-bet-limits'
        element={
          <ProtectedRoute allowedRoles={[1]}>
            <OverallBetLimits />
          </ProtectedRoute>
        }
      />
      <Route
        path='/hot-numbers'
        element={
          <ProtectedRoute allowedRoles={[1, 10]}>
            <HotNumbers />
          </ProtectedRoute>
        }
      />
      <Route
        path='/home-settings'
        element={
          <ProtectedRoute allowedRoles={[1]}>
            <HomePageSettings />
          </ProtectedRoute>
        }
      />
      <Route
        path='/finance-officers'
        element={
          <ProtectedRoute allowedRoles={[1]}>
            <FinanceOfficers />
          </ProtectedRoute>
        }
      />
      <Route
        path='/finance-officer/create'
        element={
          <ProtectedRoute allowedRoles={[1]}>
            <CreateFinanceOfficer />
          </ProtectedRoute>
        }
      />
      <Route
        path='/settings'
        element={
          <ProtectedRoute allowedRoles={[1]}>
            <Settings />
          </ProtectedRoute>
        }
      />
      <Route
        path='/users'
        element={
          <ProtectedRoute>
            <User />
          </ProtectedRoute>
        }
      />
      <Route
        path='/modify-user/:id'
        element={
          <ProtectedRoute>
            <UpdateUser />
          </ProtectedRoute>
        }
      />
      <Route
        path='/user-games/:userId'
        element={
          <ProtectedRoute>
            <UserGames />
          </ProtectedRoute>
        }
      />
      <Route
        path='/bets/:id'
        element={
          <ProtectedRoute>
            <Bets />
          </ProtectedRoute>
        }
      />
      <Route
        path='/homepage-games'
        element={
          <ProtectedRoute>
            <HomePageSettings />
          </ProtectedRoute>
        }
      />
      <Route
        path='/users-imp'
        element={
          <ProtectedRoute>
            <Users2 />
          </ProtectedRoute>
        }
      />
      <Route
        path='/payment-transactions'
        element={
          <ProtectedRoute>
            <PaymentTransactions />
          </ProtectedRoute>
        }
      />
      <Route
        path='/payment-request/:id'
        element={
          <ProtectedRoute>
            <PaymentRequest />
          </ProtectedRoute>
        }
      />
      <Route
        path='/deposit'
        element={
          <ProtectedRoute>
            <DepositPage />
          </ProtectedRoute>
        }
      />
      <Route
        path='/support'
        element={
          <ProtectedRoute>
            <Support />
          </ProtectedRoute>
        }
      />
      {/* Redirect root to home */ }
      <Route path='/' element={<Navigate to='/home' replace />} />
    </Routes>
  );
}

function App() {
  const location = useLocation();
  const isHome = location.pathname === '/home';
  const { showTermsNotice, acknowledgeTermsNotice } = useTermsNotice();
  
  return (
    <WebSocketProvider>
      {!isHome && (
        <MusicPlayer src='music/winning-the-lottery_by_commercialclips_preview.aac' />
      )}
      <BottomNavProvider>
        <AnimatePresence mode='wait'>
          <AppContent key='app-content' />
        </AnimatePresence>
        <UpdateNotifier />
        <TermsNoticePopup 
          isOpen={showTermsNotice} 
          onAcknowledge={acknowledgeTermsNotice} 
        />
      </BottomNavProvider>
    </WebSocketProvider>
  );
}

export default App;
